import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Editor from "@/pages/Editor";
import Present from "@/pages/Present";
import Summary from "@/pages/Summary";
import Branding from "@/pages/Branding";
import Play from "@/pages/Play";
import AdminUsers from "@/pages/AdminUsers";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/j/:code" element={<Play />} />
            <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/edit/:id" element={<ProtectedRoute><Editor /></ProtectedRoute>} />
            <Route path="/present/:code" element={<ProtectedRoute><Present /></ProtectedRoute>} />
            <Route path="/summary/:code" element={<ProtectedRoute><Summary /></ProtectedRoute>} />
            <Route path="/branding" element={<ProtectedRoute><Branding /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
            <Route path="*" element={<Landing />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
